import { AnimationObject } from "lottie-react-native";

export type LottieAnimationProps = LottieFileConfig;

export class LottieFileConfig {
  file: string | AnimationObject = "";
  width: number | string = 64;
  height: number | string = 64;
  duration: number = 1000;
  speed: number = 1;

  constructor(fields: Partial<LottieFileConfig>) {
    Object.assign(this, fields);
  }
}
